import { render, staticRenderFns } from "./TrainingTeacherCompany.vue?vue&type=template&id=f1a1108c"
import script from "./TrainingTeacherCompany.vue?vue&type=script&lang=js"
export * from "./TrainingTeacherCompany.vue?vue&type=script&lang=js"
import style0 from "./TrainingTeacherCompany.vue?vue&type=style&index=0&id=f1a1108c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports